import yup from "./yup-extended";

export const DebtBaseSchema = yup
  .object()
  .shape({
    if_own_debts: yup.string().required("Required")
  })
  .required();

export const DebtSchema = yup
  .object()
  .shape({
    name: yup.string().required("Required"),
    debt_type: yup.string().required("Required"),
    owner: yup.string().required("Required"),
    value: yup.string().integer(),
    split_by: yup.string().required("Required"),
    percentage: yup.lazy(values => {
      if (values && values.split_by === "percentage") {
        return yup.object().shape({
          user: yup.string().required("Required"),
          spouse: yup.string().required("Required")
        });
      }
      return yup.object().shape({
        user: yup.string(),
        spouse: yup.string()
      });
    }),
    comment: yup.string().notRequired()
  })
  .required();
